import { SalesCreateDialogComponent } from './sales-create-dialog/sales-create-dialog.component';

export * from './sales-create-dialog/sales-create-dialog.component';

export const SALES_DIALOG_COMPONENTS = [SalesCreateDialogComponent];
